$(document).ready(function () {
  $('.hero-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
  });
  $('.hero-slider-nav').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 1,
    dots: false,
    fade: true,
    arrows: false,
    focusOnSelect: true,
  });
  $('.hero .slick-prev').click(function () {
    $('.hero-slider').slick('slickPrev');
    $('.hero-slider-nav').slick('slickPrev');
  });
  $('.hero .slick-next').click(function () {
    $('.hero-slider').slick('slickNext');
    $('.hero-slider-nav').slick('slickNext');
  });
  // $('.hero-slider-nav').on(
  //   'afterChange',
  //   function (event, slick, currentSlide, nextSlide) {
  // console.log('----------');
  // console.log(currentSlide);
  // console.log(nextSlide);
  // let maxSliderIndex = slick.slideCount;
  // if (currentSlide) {
  // console.log('start');
  // $('.hero-slider').slick('slickGoTo', 0);
  // } else {
  // console.log('next');
  // }
  // $('.hero-slider').slick('slickGoTo', nextSlide);
  // }
  // );

  // let time = 7;
  // let $bar, $slick, isPause, tick, percentTime;
  // $slick = $('.carousel--slider');
  // $slick.on('init', function (event, slick) {
  //   $('.slider-progress--slide--max').html('0' + slick.slideCount);
  // });
  // $slick.slick({
  //   dots: false,
  //   pauseOnDotsHover: true,
  //   mobileFirst: true,
  //   infinite: true,
  //   arrows: false,
  //   // fade: true,
  //   draggable: true,
  // });
  // $bar = $('.slider-progress .progress');
  // $('.homepage-header--slider--text').on({
  //   mouseenter: function () {
  //     isPause = true;
  //   },
  //   mouseleave: function () {
  //     isPause = false;
  //   },
  // });
  // $slick.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  //   // startProgressbar();
  //   $('.slider-progress--slide--current').html('0' + (nextSlide + 1));
  // });
  // function startProgressbar() {
  //   resetProgressbar();
  //   percentTime = 0;
  //   isPause = false;
  //   tick = setInterval(interval, 10);
  // }
  // function interval() {
  //   if (isPause === false) {
  //     percentTime += 1 / (time + 0.1);
  //     $bar.css({
  //       width: percentTime + '%',
  //     });
  //     if (percentTime >= 100) {
  //       $slick.slick('slickNext');
  //       startProgressbar();
  //     }
  //   }
  // }
  // function resetProgressbar() {
  //   $bar.css({
  //     width: 0 + '%',
  //   });
  //   clearTimeout(tick);
  // }
  // startProgressbar();
});
